import { Updater, AsyncState, loadingAsyncState } from 'widgets-for-react'
import { initialPaginationState, PaginationState } from '../pagination/paginationState'
import { getNewsOverviewItems } from './newsOverviewApi'
import { filtersToQueryParams, NewsAndEventsFilters } from '../../utils/filtersToQueryParams'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'

export type NewsOverviewState = {
  paginationState: PaginationState
  newsItemsState: AsyncState<NewsOrEvent[]>
}

export const initialNewsOverviewState = (
  page: number,
  tags?: string[],
  department?: string,
  subDepartment?: string,
  specialist?: string,
  centrum?: string,
  subcentra?: string
): NewsOverviewState => {
  const filters: NewsAndEventsFilters = {
    tags: tags,
    department: department,
    subDepartment: subDepartment,
    specialist: specialist,
    centrum: centrum,
    subcentra: subcentra
  }
  const shouldContainExcludedTags = (filters.tags?.includes("Hoor Floor") || filters.tags?.includes("Inspiratie")) ? true : false
  return {
    paginationState: initialPaginationState(`/api/v1/pages/news/count/filter?${filtersToQueryParams(filters)}&shouldContainExcludedTags=${shouldContainExcludedTags}`),
    newsItemsState: loadingAsyncState(() => getNewsOverviewItems(filters, page)),
  }
}

export const newsOverviewStateUpdaters = {
  updateNewsCountState:
    (updater: Updater<AsyncState<number>>) =>
    (currentState: NewsOverviewState): NewsOverviewState => ({
      ...currentState,
      paginationState: updater(currentState.paginationState),
    }),
  updateNewsItemsState:
    (updater: Updater<AsyncState<NewsOrEvent[]>>) =>
    (currentState: NewsOverviewState): NewsOverviewState => ({
      ...currentState,
      newsItemsState: updater(currentState.newsItemsState),
    }),
}
